import { Box, Center, VStack, Heading } from '@chakra-ui/react';
import { useNavigate } from 'react-router';
import { MdHelpOutline } from 'react-icons/md';
import FaceliftButton from '@/components/Atoms/FaceliftButton/FaceliftButton';
import FaceliftText from '@/components/Atoms/FaceliftText/FaceliftText';
import usePermission from '@/hooks/usePermission';
import { useAuthStore } from '@/store';
import { useMemo } from 'react';
import { permissionToUrl } from '@/constants';

const Error404 = () => {
  const navigate = useNavigate();

  const { hasPermission } = usePermission();
	const user = useAuthStore((state) => state.user?.userInformation);

	const firstMatchedRouteAsPerPermission = useMemo(() => Object.entries(permissionToUrl).find(([permission, _]) => {
		return hasPermission([permission]);
	}), [hasPermission, user]);

  const handleBackToHome = () => {
    navigate(firstMatchedRouteAsPerPermission?.at(1) || '/profile');
  };

  return (
    <Center minH="100vh" bg="brand.pageBackground" px={{ base: 4, md: 8 }}>
      <VStack gap={4} maxW="500px" textAlign="center">
        {/* Error Code */}
        <Heading
          fontSize={{ base: '5xl', md: '6xl' }}
          fontWeight="bold"
          color="brand.robotGrey"
          lineHeight="1"
        >
          404
        </Heading>

        {/* Main Message with Icon */}
        <Box display="flex" alignItems="center" gap={3}>
          <Box
            width={{ base: '40px', md: '50px' }}
            height={{ base: '40px', md: '50px' }}
            borderRadius="full"
            bg="brand.robotGrey"
            display="flex"
            alignItems="center"
            justifyContent="center"
            flexShrink={0}
          >
            <MdHelpOutline size={28} color="white" />
          </Box>
          <Heading
            fontSize={{ base: 'lg', md: 'xl' }}
            fontWeight="600"
            color="brand.textDark"
          >
            Page Not Found
          </Heading>
        </Box>

        {/* Subtitle */}
        <FaceliftText
          fontSize={{ base: 'sm', md: 'md' }}
          color="brand.textDark"
          opacity={0.7}
          maxW="400px"
        >
          The page you're looking for doesn't exist or has been moved. Let's get
          you back on track.
        </FaceliftText>

        {/* Action Button */}
        <FaceliftButton
          onClick={handleBackToHome}
          size="sm"
          mt={2}
          _hover={{ opacity: 0.9 }}
        >
          Back to Home
        </FaceliftButton>
      </VStack>
    </Center>
  );
};

export default Error404;

